import { ref, computed, reactive } from 'vue';
import { defineStore } from 'pinia';
import { useAtomicSetter } from '@/composables/useAtomicSetter.js';

const useTransferRecipientDrawerStore = defineStore('transfer-recipient-drawer', () => {
  const recipientId = ref(null);
  const agencyId = ref(null);

  const isOpen = computed(() => !!recipientId.value);

  const stateRefs = {
    recipientId,
    agencyId,
  };

  const { setAtomic } = useAtomicSetter(stateRefs);

  const closeDrawer = () => {
    setAtomic('recipientId', null);
    setAtomic('agencyId', null);
  };

  return {
    ...stateRefs,
    isOpen,
    setAtomic,
    closeDrawer,
  };
});

const useTransferRecipientsStore = defineStore('transfer-recipients', () => {
  const filters = reactive({
    page: 1,
    sort_by: 'created_at',
    sort_order: 'desc',
    per_page: 25,
  });

  const shouldResetFilters = ref(true);

  const stateRefs = {
    shouldResetFilters,
  };

  const { setAtomic } = useAtomicSetter(stateRefs);

  const setFilters = (newFilters) => {
    Object.assign(filters, newFilters);
  };

  const resetFilters = () => {
    Object.assign(filters, { page: 1 });
  };

  return { filters, setFilters, ...stateRefs, setAtomic, resetFilters };
});

const useTransferRecipientIdentifiersStore = defineStore('transfer-recipient-identifiers', () => {
  const filters = reactive({
    search_text: '',
    sort_by: 'created_at',
    sort_order: 'desc',
    page: 1,
    per_page: 20,
  });

  const shouldResetFilters = ref(true);

  const stateRefs = {
    shouldResetFilters,
  };

  const { setAtomic } = useAtomicSetter(stateRefs);

  const setFilters = (newFilters) => {
    Object.assign(filters, newFilters);
  };

  const resetFilters = () => {
    Object.assign(filters, { page: 1, search_text: '' });
  };

  return { filters, setFilters, ...stateRefs, setAtomic, resetFilters };
});

export { useTransferRecipientDrawerStore, useTransferRecipientsStore, useTransferRecipientIdentifiersStore };
